<script setup lang="ts">
interface Props {
  title?: string
  link?: string
  linkLabel?: string
}

defineProps<Props>()
</script>

<template>
  <div class="section-title">
    <div class="section-title__heading">
      <h2
        v-if="title"
        class="section-title__title"
      >
        {{ title }}
      </h2>
      <a
        v-if="link"
        :href="link"
        class="section-title__link"
      >{{ linkLabel || 'View All' }}</a>
    </div>
  </div>
</template>

<style lang="scss">
.section-title {
  @apply mb-[30px];
  @apply md:mb-[40px];
  @apply xl:mb-[50px];

  &__heading {
    @apply flex items-end justify-between;
  }

  &__title {
    @apply text-[26px] text-dark-text font-medium leading-[1];
    @apply md:text-[30px];
    @apply lg:text-[40px];
    @apply xl:text-[60px];
  }

  &__link {
    @apply text-[14px] text-dark-text underline;
    @apply md:text-[18px];
    @apply hover:decoration-transparent;
  }
}
</style>
